import * as layout from '../layout.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";

let tabSwiper;

function pageHeading() {
    const pageHeader = layout.select('.menu-header');
    pageHeader.style.paddingTop = `${layout.navbarHeight}px`;
}

function initSwiper(target) {

    let swiperTarget = target.querySelector('.menu__header-swiper');
    let swiperPrev = target.querySelector('.menu__swiper-navigation-prev');
    let swiperNext = target.querySelector('.menu__swiper-navigation-next');
    let swiperPagination = target.querySelector('.menu__swiper-pagination');

    // init swiper based
    tabSwiper = new Swiper(swiperTarget, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 'auto',
        autoplay: {
            delay: 3000,
        },
        loop: true,
        spaceBetween: 0,
        pagination: {
            el: swiperPagination
        },
        navigation: {
            prevEl: swiperPrev,
            nextEl: swiperNext
        },
    })
}

function initFancyBox() {

    const slideClickHandler = (target, fancyboxRef) => {
        if (target.classList.contains('fancybox__slide')) {
            fancyboxRef.close();
        }
    }

    Fancybox.bind("[data-fancybox]", {
        on: {
            done: (fancyboxRef) => {
                document.addEventListener('click', (e) => slideClickHandler(e.target, fancyboxRef))
            },
            close: () => {
                document.removeEventListener('click', slideClickHandler)
            }
        }
    });
}

window.addEventListener('load', () => {
    pageHeading()
    initSwiper(document)
    initFancyBox();
})